import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IAutomationReason {
  label: string;
  value: string;
}

export interface IAutomationVariable {
  variable: string;
  status: 'pending' | 'approved' | 'rejected';
  approved: boolean | null;
  reviewed_reasons: IAutomationReason[];
  rejection_reasons: IAutomationReason[];
  comment: string | null;
}

export interface IAutomationSummary {
  total: number;
  approved: number;
  rejected: number;
  pending: number;
}

export interface IAutomationState {
  summary: IAutomationSummary;
  variables: IAutomationVariable[];
}

const initialState: IAutomationState = {
  summary: { total: 0, approved: 0, rejected: 0, pending: 0 },
  variables: [],
};

const automationSlice = createSlice({
  name: 'automationStore',
  initialState,
  reducers: {
    setAutomationData: (
      state,
      action: PayloadAction<{
        summary: IAutomationSummary;
        variables: IAutomationVariable[];
      }>
    ) => {
      state.summary = action.payload.summary;
      state.variables = action.payload.variables;
    },
    resetAutomationData: state => {
      state.summary = initialState.summary;
      state.variables = [];
    },
  },
});

export const { setAutomationData, resetAutomationData } =
  automationSlice.actions;
export default automationSlice.reducer;
